import { render, staticRenderFns } from "./users-event.vue?vue&type=template&id=192cfc82&"
import script from "./users-event.vue?vue&type=script&lang=js&"
export * from "./users-event.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports